import { requestTool } from "../tools";

const post = (url, sendData,headers) => {
    return requestTool.postRequest(url, sendData,headers)

}
const get = (url, sendData,headers) => {
    return requestTool.getRequest(url, sendData,headers)

}
const requestService = (url, sendData, method,headers) => {
    return method === "GET" ? get(url, sendData,headers) : post(url, sendData,headers);

}



export const autoCompleteService = { post, get, requestService };

export default autoCompleteService;

